import { render, staticRenderFns } from "./pointPackage.vue?vue&type=template&id=fed85108&"
import script from "./pointPackage.vue?vue&type=script&lang=js&"
export * from "./pointPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports